<div class="main-content" *ngIf="staticPageResponse != null && staticPageResponse.length > 0">
  <div class="installation">
    <div class="banner">
      <picture>
        <source media="(max-width:768px)" [srcset]="staticPageResponse[0].mobileImageFileUrl" />
        <img loading="lazy" [src]="staticPageResponse[0].pageImageFileUrl" [alt]="staticPageResponse[0].pageImageAltTag" />
      </picture>
    </div>
    <div class="container mt-5" *ngFor="let staticPage of staticPageResponse; let index = index">
      <h1 class="mb-5" *ngIf="index == 1">{{ staticPage?.pageheading }}</h1>
      <h2 class="mb-5" *ngIf="index != 1">{{ staticPage?.pageheading }}</h2>
      <div [innerHTML]="staticPage?.description"></div>
      <iframe class="cst-video" *ngIf="staticPage.videoLink" [src]="getSafeVideoUrl(staticPage.videoLink)" title="YouTube video player"
        frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen></iframe>
    </div>
  </div>
</div>
